import { c2cPostApiHandler } from "../c2cApiHandler";
import { C2CConsole } from "./C2CConsole";

class C2CLogger {
  loggerApiCall(payload) {
    const resData = c2cPostApiHandler(
      "public/frontend-cloudwatch-logs",
      payload
    );
    resData.then(([res, err]) => {
      if (!err && res) {
        C2CConsole.log("cloudwatch response", res);
      } else {
        C2CConsole.log("cloudwatch error", err);
      }
    });
  }

  error(message) {
    let payload = {
      logType: "error",
      message: message
    };

    this.loggerApiCall(payload);
  }

  warn(message) {
    let payload = {
      logType: "warning",
      message: message
    };

    this.loggerApiCall(payload);
  }

  info(message) {
    let payload = {
      logType: "info",
      message: message
    };

    this.loggerApiCall(payload);
  }
}

export default C2CLogger;
